var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPlayList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 57.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#40ba8e;fill-rule:evenodd;}.cls-2{fill:#2e3e36;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1_copy_22",
    "data-name": "Rounded Rectangle 1 copy 22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.2,59.25H82.29V47.34a2.72,2.72,0,0,0-5.43,0V59.25H65.37a2.72,2.72,0,0,0,0,5.43H76.86V76.17a2.72,2.72,0,0,0,5.43,0V64.68H94.2a2.72,2.72,0,0,0,0-5.43Z",
    transform: "translate(-2.92 -21.23)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1_copy_19",
    "data-name": "Rounded Rectangle 1 copy 19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70,40H5.63a2.72,2.72,0,0,0,0,5.43H70A2.72,2.72,0,0,0,70,40ZM54.51,58.83H5.63a2.72,2.72,0,0,0,0,5.43H54.51a2.72,2.72,0,1,0,0-5.43ZM5.63,26.66H70a2.72,2.72,0,0,0,0-5.43H5.63a2.72,2.72,0,0,0,0,5.43Z",
    transform: "translate(-2.92 -21.23)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPlayList);
export default __webpack_public_path__ + "static/media/myPlayList.95a633b26706e2a7b0d30f36ae04b7c8.svg";
export { ForwardRef as ReactComponent };